import useGetSharedVehicleLookup from '/business/shared/components/questions/_util_hooks/useGetSharedVehicleLookup';

export default function useGetEstimatedCarSchema({ dealershipName }: { dealershipName?: string | null }) {
  return useGetSharedVehicleLookup({
    inputLabel: 'Estimated distance travelled by car for all employees',
    // TODO: [WR] do we need it?
    // applicationDealershipName: dealershipName,
    prependCarField: true,
  });
}
